import { Grid, Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import React, { useEffect } from "react";
import { CheckBox } from "../../../Common/FormFields/CheckBox";
import { Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import RoundButton from "../../../Common/RoundButton";
import { postLegalAuthorization } from "./legalActions";
import { Link, useHistory } from "react-router-dom";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import CardsTheme from "../../../Common/P2P/Header/CardsTheme";
import ErrorMessage from "../../../Common/ErrorMessage";
import LenderAgreement from "../../../utils/assests/lender-agreement.png";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ProgressBar from "../../../Common/ProgressBar";

const LegalAuth = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { legalResponse, error } = useSelector((state: any) => state.legalAuth);
  const { confirmOTPResponse } = useSelector((state: any) => state.login);

  useEffect(()=> {
    document.title = "stashearn - legal-auth"
  },[])

  useEffect(()=>{
    if (legalResponse && legalResponse?.message === "Agreed Successfully") {
      history.push({
        pathname: "/p2p/dashboard",
      });
    }
  },[legalResponse])

  const initialValues = {
    autLetter: false,
    rbiCompliance: false,
  };

  const validationSchema = () =>
    Yup.object().shape({
      autLetter: Yup.bool().oneOf([true], "*Please accept terms & conditions"),
      rbiCompliance: Yup.bool().oneOf(
        [true],
        "*Please accept terms & conditions"
      ),
    });

  const onSubmitHandle = (value: any) => {
    dispatch(postLegalAuthorization(value));
  };

  return (
    <>
      <BackgroundTheme>
        <Grid>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(value) => onSubmitHandle(value)}
          >
            {({ handleSubmit, values, touched, errors }) => (
              <Form>
                {/* <Box className="legarAuth">
                  <Typography
                    variant="h1"
                    className="text-blue text-center fs-25 fw-800 MuiTypography-h1"
                  >
                    Lender registration agreement
                  </Typography>
                  <img src={LenderAgreement} alt='' />
                  <Typography
                    variant='h2'
                    className='text-center fs-20 fw-300 text-gray-four'
                  >
                    You are 1 step away from <br /> earning attractive returns
                  </Typography>
                  <a href='/p2p/authorityLetter'>Read all documents</a>
                  <div className='termsAndConditions'>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox defaultChecked color='default' sx={{ fontSize: '10px' }} />
                        }
                        label={<p>I accept the terms.</p>}
                      />
                    </FormGroup>
                  </div>
                </Box> */}
            
               <Box style={{ marginTop: '10px' }}>
                  <CardsTheme>
                    <AccordionSummary
                      style={{ borderRadius: "5px" }}
                      expandIcon={<ExpandLessIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography variant="h6">Authorization Letter</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography component="span">
                        Hi {confirmOTPResponse?.results?.response?.full_name}
                        <br /> We need your authorisation to complete any
                        lending transaction initiated by you. This authorisation
                        also helps us initiate legal action against the borrower
                        in case of default. For any query on this, please get in
                        touch with our customer service officer at
                        cs@lendenclub.com.
                      </Typography>
                      <Typography
                        component="span"
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          fontWeight: 600,
                          color: '#000066'
                        }}
                      >
                        <a href="/p2p/authorityLetter">read more </a>
                      </Typography>
                    </AccordionDetails>
                    <Field
                      component={CheckBox}
                      name="autLetter"
                      isinnerhtml="true"
                      label={`I accept the <strong>Terms</strong>`}
                    />
                  </CardsTheme>
                </Box>
                  <Box style={{ marginTop: "10px" }}>
                  <CardsTheme>
                    <AccordionSummary
                      expandIcon={<ExpandLessIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography variant="h6">RBI Compliance</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography component="span">
                        Based on RBI regulations for Peer to Peer lending
                        platforms we require the below mentioned confirmation
                        from you:
                        <br></br>
                        1. If I have invested more than Rs. 50,00,000 across P2P
                        Lending Platforms in India, I will stop lending on
                        LenDenClub.
                        <br></br>
                        2. I will not lend more than Rs. 50,000 to a single
                        borrower on P2P lending platforms including LenDenClub.
                      </Typography>
                    </AccordionDetails>
                    <Field
                      component={CheckBox}
                      name="rbiCompliance"
                      isinnerhtml="true"
                      label={`I accept the <strong>Terms</strong>`}
                    />
                  </CardsTheme>
                      </Box>
                {
                  error && 
                  <div style={{ marginBottom: "10px", marginTop: '20px' }}>
                  <ErrorMessage text={error}/>
                  </div>
                }
                <div style={{ marginBottom: "10px", marginTop: '20px' }}>
                  <RoundButton title="Proceed" type="submit" />
                </div>
              </Form>
            )}
          </Formik>
        </Grid>
      </BackgroundTheme>
    </>
  );
};

export default LegalAuth;